<template>
  <div class="hello">
    <el-container id="naver">
      <div class="top lbg titlebox" :class="{ banner: schooltop }" v-if="this.$route.path != '/evaluation'">
        <div class="titles">
          <a href="/" class="logo fl">
            <img style="width: auto; height: 65px" :src="matchLogo" />
          </a>
          <div class="fl logo-text" style="color:#00baff ">
            <div v-html="matchName" style="line-height: 36px;"></div>
            <!-- <div>2020年吉林省“吉人梦想杯”</div>
            <div>大学生职业生涯规划大赛</div> -->
          </div>
        </div>

        <div class="tabBox">
          <div v-for="(item, index) in tabList" :key="index" @click="getTab(index, item.path)"
            class="item">
            <div
              :class="tabIndex == index ? 'itemChack' : ''">
              {{ item.name }}</div>
            <div style=""></div>
          </div>
          <div class="exit" @click="quiet" v-if="userId">退出登录</div>
          <!-- <a @click="goAnchor('#download')">资料下载</a> -->
          <!-- <router-link to='/'>参赛锦囊</router-link> -->
        </div>
        <!-- <div class="operat fr">
          <router-link
            v-if="showSelf"
            to="/myWork"
            class="manage_entry tc"
            style="color: #fff !important"
            >报名中心
          </router-link>
          <a v-if="showSelf" @click="quiet" class="" style="font-size: 16px"
            >退出</a
          >
          <router-link v-else to="/login" class="manage_entry tc"
            >报名入口</router-link
          >
          <a href="/mms" class="" style="font-size: 16px" target="_blank"
            >专家入口</a
          >
          <router-link to='/register'>注册</router-link>
          <a href="/mms" class="" style="font-size: 16px" target="_blank"
            >管理入口</a
          >
        </div> -->
      </div>
      <router-view :style="{ 'margin-top': tabIndex == 0 ? '0' : '70px' }"></router-view>

      <el-footer v-if="this.$route.path != '/evaluation'">
        <div class="foot hbg">
          <div class="container">
            <p>技术支持单位:北京位来教育科技有限公司 CopyRight 2021</p>
            <!-- <p>备案号 :京ICP备20011457号-1</p> -->
            <div class="banumber">
              <a class="banumber_text"
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502044793" target="_blank"
                style="margin-right: 1.5rem;">京公网安备11010502044793号</a>
              <a class="banumber_text" href="https://beian.miit.gov.cn" target="_blank">京ICP备20011457号-1</a>
            </div>
            <!-- <div class="foot_item mr24 fl">
                <div class="f_title"><b>主办单位</b><span class="f_tip f_lgray"><b>承办单位</b></span></div>
                <div class="f_det">
                    主办单位：吉林省高等学校毕业生就业指导中心<br/>

                    承办单位：长春理工大学<br/>
                             北京位来教育科技有限公司
                </div>
            </div>
            <div class="foot_item mr24 fl">
                <div class="f_title"><b>大赛组委会联系方式</b></div>
                <div class="f_det">
                    吉林省高等学校毕业生就业指导中心<br/>
                    联系人：宋 姣   秦 宁<br/>
                    电话：0431-84685991  15948043331  13596126121<br/>
                    长春理工大学就业创业指导中心<br/>
                    联系人：王宇超  王 璐<br/>
                    电话：0431-85582660  13944189353  15604466328<br/>
                    北京位来教育科技有限公司<br/>
                    联系人：金晓彤  电话：15904317043<br/>

                </div>
            </div>
            <div class="foot_item fr">
                <div class="f_title"><b>大赛技术支持</b></div>
                <div class="f_det">
                    北京位来教育科技有限公司<br />
                    联系人：金晓彤 电话：15904317043<br />
                    联系人：程明   电话：13341456103<br />

                </div>
            </div> -->
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import { Session } from "@/utils/storage";
import { getDomain } from "@/utils/toos";
import { getHomeData } from "../api/home";
import { getUserInfo } from "@/api/mywork";
import eventBus from '../views/user/eventBus';
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      params: {
        domain: "",
        //   id:14
      },
      matchId: "",
      showSelf: "",
      matchLogo: "",
      matchName: "",
      schooltop: false,
      tabIndex: 0,
      tabList: [
        { name: '首页', path: 'home' },
        { name: '赛事介绍', path: 'introduced' },
        { name: '赛事新闻', path: 'news' },
        { name: '赛事通知', path: 'notice' },
        { name: '资料下载', path: '' },
      ],
      isFixed:false,
      userId: ''
    };
  },
  created() {
    let isweacht = this.isWechat();
    if (isweacht) {
      this.$router.push("/norightWeb");
    }
    getDomain();
    this.params.domain = Session.get("domain");
    getHomeData(this.params).then((res) => {
      Session.set("enableEvaluation", res.data.data.enableEvaluation);
      Session.set("enableSort", res.data.data.enableSort);
      if (res.data.data == null) {
        this.$router.push("/nomatch");
      }
      if (!this.params.domain) {
        this.$router.push("/nomatch");
      }
      if (!res.data.data) {
        this.matchId = 0;
      } else {
        this.matchId = res.data.data.id;
      }
      // 存储 domain 到浏览器缓存
      Session.set("matchID", this.matchId);
      if (res.data.data) {
        this.matchLogo = res.data.data.matchLogo;
        if (res.data.data.matchName.indexOf(" ") != -1) {
          this.matchName = res.data.data.matchName.replace(" ", "<br/>");
        } else {
          this.matchName = res.data.data.matchName;
        }
        document.title = res.data.data.matchName;
        Session.set("ifOpen", res.data.data.ifOpen);
        Session.set("matchLogo", this.matchLogo);
      }
    });
    switch (this.$route.name) {
      case 'introduced':
        this.tabIndex = 1
        break;
      case 'news':
        this.tabIndex = 2
        break;
      case 'notice':
        this.tabIndex = 3
        break;
      case 'noticInfo':
        this.tabIndex = 3
        break;
      case 'NewsMore':
        this.tabIndex = 2
        break;
      case 'SchoolMore':
        this.tabIndex = 2
        break;
      case 'newsInfo':
        this.tabIndex = 2
        break;
      default:
        break;
    }
    window.addEventListener('scroll', this.handleScroll)
    eventBus.$on('loginSuccess', (userId) => {
      console.log("监听到了",userId);
      this.userId = userId; // 更新数据
    });
  },
  beforeDestroy() {
    // 组件销毁前移除监听器，防止内存泄漏
    eventBus.$off('loginSuccess');
  },
  mounted() {
    let schooltop = document.documentElement.scrollTop;
    //  window.onmousewheel = document.onmousewheel = this.scrollFunc();
    if (schooltop == 0) {
      this.schooltop = true;
    }
    this.showSelf = Session.get("token");
    console.log("当前路由是", this.$route.path);
  },
  methods: {
    quiet() {
      Session.clear();
      this.showSelf = false;
      this.$router.push("/home");
      this.userId = Session.get("userId")
      this.tabIndex = 0
    },
    //锚点跳转
    goAnchor(selector) {
      this.$router
        .push({
          path: "/home",
          query: {
            mao: 1,
          },
        })
        .catch((err) => err);
      var anchor = this.$el.querySelector(selector); // 参数为要跳转到的元素id,是(#id)
      if (anchor != null) {
        document.body.scrollTop = anchor.offsetTop; // chrome
        document.documentElement.scrollTop = anchor.offsetTop; // firefox
      }
    },
    isWechat() {
      let ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    getTab(i, path) {
      if (path == '') {
        this.goAnchor('#download')
      } else {
        this.$router.push({
          name: path
        })
      }
      this.tabIndex = i
    },
    //滚动监听
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
          .scrollTop
      let offsetTop = document.querySelector('#naver').offsetTop;
      this.isFixed = scrollTop > offsetTop + 200 ? true : false;

    },
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  background: #EFF0F5;
}
.titlebox{
  background-color: #fff;
  padding-right: 100px;
}
.titles{
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 40%;
}
.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-footer {
  margin-top: 30px;
  padding: 0;
}

.el-header {
  display: flex;
  align-items: center;
  height: 100px !important;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  line-height: 160px;
}

body>.el-container {
  margin-bottom: 40px;
}

.logo-text {
  padding-left: 10px;
  font-weight: bold;
  font-size: 30px;
  text-align: center;
  font-style: italic;
  /* flex: 1; */
}

.top {
  overflow: hidden;
}

.lbg {
  /* background: rgba(0,0,0,.2); */
  background-color: #fff;
  position: fixed;
  right: 0;
  left: 0;
  z-index: 1030;
  /* color:#fff; */
  height: 100px;
  color: black;
  /*border-bottom: 1px solid #d8d8d8;*/
  display: flex;
  align-items: center;
  display: flex;
  justify-content: center;
}

.lbg.banner {
  background: #fff;
  color: #fff;
}

.top .logo {
  margin-left: 0;
}

.top .tabBox {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 20px;
  color: #000000;
  flex: 0.6;
  display: flex;
  text-align: right;
}

/* 普通选中样式 */
.top .tabBox .item {
  cursor: pointer;
  height: 100%;
  flex: 0.7;
}

.top .tabBox .item:hover {
  color: #4F90FD;
}

/* 普通选中样式 */
.top .tabBox .itemChack {
  font-weight: 600;
}

/* 首页选中样式 */
.top .tabBox .item1 {
  margin-right: 5.4em;
  cursor: pointer;
  color: #ffffff;
  height: 100%;
}
.top .tabBox .item1:hover{
  color: #4F90FD;
}
/* 首页选中样式 */
.top .tabBox .itemChack1 {
  font-weight: 600;
  color: #ffffff;
}
/* 首页退出登录 */
.top .tabBox .exit{
  color: red;
  cursor: pointer;
  flex: 0.7;
}
.lbg a {
  color: black;
}

.fl,
.pull-left {
  float: left;
}

.logo-text {
  padding-left: 10px;
  padding-top: 0px;
  font-weight: bold;
  font-size: 30px;
  text-align: center;
  line-height: 27px;
  color: #00baff;
}

.top .operat a {
  margin: 0 40px 0 0;
}

.top .nav a {
  margin-left: 50px;
  line-height: 39px;
  font-size: 16px;
  float: left;
  padding: 15px;
  min-width: 94px;
  text-align: center;
}

.fr,
.pull-right {
  float: right;
  display: flex;
  align-items: center;
  height: 100%;
  position: absolute;
  right: 0;
}

.top a.manage_entry {
  margin: 0;
  width: 140px;
  font-size: 16px;
  color: #fff;
  /* background: #fb8d00; */
  display: inline-block;
  line-height: 40px;
  -webkit-transition: all 0.7s;
  -moz-transition: all 0.7s;
  -ms-transition: all 0.7s;
  -o-transition: all 0.7s;
  transition: all 0.7s;
  border: 1px solid #00baff;
  background-color: #00baff;
  border-radius: 8px;
  margin-right: 25px;
}

.tc {
  text-align: center;
}

/* .top a.manage_entry:hover {
      color: #fff !important;
      background: #0e3e86;
  }
  .top .nav a:hover, .top .operat a:hover {
      color: #9dcfff;
  } */
a:focus,
a:hover {
  text-decoration: none;
}

.hbg {
  height: 300px;
  background: #333333;
  padding-top: 117px;
  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
}

.container {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  padding: 0;
}

.banumber {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.banumber_text {
  text-decoration: none;
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  line-height: 40px;
}

.banumber_text:hover {
  color: #ffffff !important;
}

.foot .foot_item {
  width: 384px;
  padding: 40px 0 60px;
}

.banner .slideBox .bd img {
  width: 100%;
  display: block;
}

.banner {
  width: 100%;
  overflow: hidden;
}

.banner .slideBox {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.banner .slideBox .bd {
  position: relative;
  height: 100%;
  z-index: 0;
}

.banner .slideBox .bd ul {
  width: 100%;
}

.banner .slideBox .bd li {
  zoom: 1;
  vertical-align: middle;
}

.bd ul {
  padding: 0;
}

.nav.fl {
  margin-left: 50px !important;
}

.top.lbg {
  padding-left: 50px !important;
}

/* 移动端 */
@media screen and (max-width: 1500px) {
  .top .nav a {
    margin-left: 0;
  }
}
@media screen and (max-width: 1600px){
  .top .tabBox {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 20px;
    color: #000000;
    flex: 0.8;
    display: flex;
    text-align: right;
  }
}
@media screen and (max-width: 1100px) {
  .titles{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
  }
  .logo-text{
    padding-left: 10px;
    padding-top: 0px;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    line-height: 27px;
    color: #00baff;
  }
  .top .tabBox {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 15px;
    color: #000000;
    flex: 1;
    display: flex;
    text-align: right;
  }

  /* 普通选中样式 */
  .top .tabBox .item {
    cursor: pointer;
    height: 100%;
    flex: 1;
  }

  .top .tabBox .item:hover {
    color: #4F90FD;
  }

  /* 普通选中样式 */
  .top .tabBox .itemChack {
    font-weight: 600;
  }

  /* 首页选中样式 */
  .top .tabBox .item1 {
    margin-right: 3.4em;
    cursor: pointer;
    color: #ffffff;
    height: 100%;
  }
  .top .tabBox .item1:hover{
    color: #4F90FD;
  }
  /* 首页选中样式 */
  .top .tabBox .itemChack1 {
    font-weight: 600;
    color: #ffffff;
  }
  /* 首页退出登录 */
  .top .tabBox .exit{
    color: red;
    cursor: pointer;
    flex: 1;
  }
  .container {
    width: auto;
  }

  .top .nav a {
    margin-left: 0px;
    line-height: 0px;
    font-size: 16px;
    float: left;
    padding: 13px;
    min-width: 68px;
    text-align: center;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 18px;
  }

  .nav.fl {
    margin-left: 0 !important;
    position: absolute;
    left: 0;
    top: 70px;
    display: flex;
    /* overflow: scroll; */
    width: 100vw;
    background-color: #fff;
    height: 40px;
    align-items: center;
    border-bottom: 1px solid #ccc;
    justify-content: space-around;
  }

  a.logo.fl img {
    height: 55px;
  }

  .router-link-active {
    background: none;
    border-width: 3px;
  }

  .banner {
    overflow: inherit;
  }

  .operat.fr a:last-child {
    display: none;
  }

  .top .nav a:last-child {
    display: none;
  }

  .lbg.banner {
    /* background: #00baff; */
    color: #fff;
    border-bottom: 1px solid #ccc;
  }
}
@media screen and (max-width: 1500px) {
  .logo-text{
    padding-left: 10px;
    padding-top: 0px;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    line-height: 27px;
    color: #00baff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue